import { Modal } from "@visiblethread/react-components";
import DocStyleTemplatesDropdown, {
  TEMPLATES_ERROR_MESSAGE,
} from "components/DocStyleTemplatesDropdown";
import { useContext, useState } from "react";
import isNullish from "utils/isNullish";

import StartWritingProposalOutlineContext from "../context";
import { STEPS_KEYS } from "../StartWritingProposalOutlineWizard";
import common from "./common.module.scss";
import { GENERATE_BTN, NEXT_BTN } from "./constants";
import ModalFooter from "./ModalFooter";
import WizardProgressBar from "./WizardProgressBar";

const ChooseStyleTemplates = () => {
  const {
    hasConflicts,
    onConfirmStart,
    setStep,
    setTemplateId,
    source,
    templateId,
  } = useContext(StartWritingProposalOutlineContext);
  const hasNoTemplateId = isNullish(templateId);
  const [error, setError] = useState();

  const onSelectTemplate = (id) => {
    setError(undefined);
    setTemplateId(id);
  };

  const onClickNext = () => {
    if (hasNoTemplateId) {
      setError(TEMPLATES_ERROR_MESSAGE);
      return;
    }

    if (!hasConflicts) {
      onConfirmStart(source, templateId);
      return;
    }

    setStep(STEPS_KEYS.CONFLICTS);
  };

  return (
    <>
      <Modal.Body className={common.body}>
        <h4>Choose your Style Template</h4>
        <p>Choose the styles which work best for this document.</p>

        <WizardProgressBar value={50} />

        <DocStyleTemplatesDropdown error={error} onSelect={onSelectTemplate} />
      </Modal.Body>

      <ModalFooter
        onClickNext={onClickNext}
        nextButtonText={hasConflicts ? NEXT_BTN : GENERATE_BTN}
        stepNumber={2}
      />
    </>
  );
};

export default ChooseStyleTemplates;
